// extracted by mini-css-extract-plugin
export default {"formShow":"Profile_formShow__C8KX6","edit_icon":"Profile_edit_icon__mK6Ql"};